import { CheckCircle2, ShieldPlus, ServerCog } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const roleCards = [
  { label: "Directory Services", role: "AD-Domain-Services" },
  { label: "DNS Server", role: "DNS" },
  { label: "DHCP Server", role: "DHCP" },
  { label: "File Services", role: "File-Services" }
];

export function ServerManagerApp({ activeMachine, onOpenApp, onRunCommand, profile }: SimulatorAppSurfaceProps) {
  return (
    <div className="fd-sim-app fd-sim-server-manager">
      <aside className="fd-server-nav">
        <strong>{profile.productLabel}</strong>
        <button className="is-active" type="button">Dashboard</button>
        <button type="button" onClick={() => onOpenApp("aduc", "start")}>Directory</button>
        <button type="button" onClick={() => onOpenApp("dns-manager", "start")}>DNS</button>
        <button type="button" onClick={() => onOpenApp("dhcpManager", "start")}>DHCP</button>
        <button type="button" onClick={() => onOpenApp("gpmc", "start")}>Policy</button>
      </aside>
      <section className="fd-server-dashboard">
        <header>
          <p>{activeMachine}</p>
          <h2>Server Manager-style Console</h2>
        </header>
        <div className="fd-server-role-grid">
          {roleCards.map((role) => (
            <button
              key={role.role}
              type="button"
              onClick={() => {
                void onRunCommand({
                  appId: "server-manager",
                  commandType: "SERVER_ROLE_INSTALL",
                  capability: "serverRoles.write",
                  label: role.label,
                  payload: { machineId: activeMachine, role: role.role, roleName: role.role }
                });
              }}
            >
              <ServerCog size={22} />
              <span>{role.label}</span>
              <small>Add role</small>
            </button>
          ))}
        </div>
        <div className="fd-server-actions">
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: "server-manager",
                commandType: "SERVER_DC_PROMOTE",
                capability: "serverRoles.write",
                label: "Promote server",
                payload: { domainName: "advanced-ti.local", machineId: activeMachine }
              });
            }}
          >
            <ShieldPlus size={17} />
            Promote server
          </button>
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: "server-manager",
                commandType: "RECORD_APP_CHECK",
                capability: "serverRoles.read",
                label: "Refresh dashboard",
                payload: { appId: "server-manager", machineId: activeMachine, title: "Server Manager-style Console" }
              });
            }}
          >
            <CheckCircle2 size={17} />
            Refresh
          </button>
        </div>
      </section>
    </div>
  );
}
